import './CurriculumCI.scss';
import { ReactComponent as OpenCIIcon } from './../../../../assets/images/openEye.svg';
import { ReactComponent as DownLoadIcon } from './../../../../assets/images/download.svg';
import { ReactComponent as ContentItemIcon } from './../../../../assets/images/contenItemIcon.svg';
import CurriculumCIProps from "./CurriculumCIProps";
import contentService from "../../../../Axios/services/content.service";
import { useLocation } from "react-router-dom";
import { isMobileApp } from "../../../../helpers/helpers";

const CurriculumCI = ({ item, mode, language }: CurriculumCIProps) => {
  const location = useLocation();
  const isMobile = isMobileApp();
  
  const openContent = async (id) => {
    localStorage.setItem("currentPath", location.pathname);
    const content = await contentService.get(id);
    if (
      (content.media[0].link && content.media[0].link.includes("vimeo")) ||
      (content.media[0].link && content.media[0].link.includes("youtube")) ||
      (content.media[0].azureLink && content.media[0].azureLink.includes("publishedfiles")) ||
      (content.media[0].azureLink && content.media[0].azureLink.includes("hnprodfilestorage")) ||
      (content.media[0].azureLink && content.media[0].azureLink.includes("testpublishedfiles"))
    ) {
      window.open("/content/" + id, "_self")?.focus();
      return;
    } else {
      const target = isMobile ? "_self" : "_blank";
      window.open(content.media[0].link, target)?.focus();
      return;
    }
  };

  const downloadContent = async (e, id) => {
    const content = await contentService.get(id);
    e.stopPropagation();
    window.open(content.media[0].azureLink, "_self");
  };

  return item ? (
    <div
      className={`${
        location.pathname.includes("/my-campus/event/timeline")
          ? "d-flex flex-column contentItemWrapper contentItemWrapperTimeLine"
          : "d-flex flex-column contentItemWrapper"
      } ${localStorage.getItem("entityLanguage") === "English" ? null : "text-right"}`}
    >
      <div className="d-flex flex-row">
        <ContentItemIcon className="mr-2" />
        <div
          className={location.pathname.includes("/my-campus/event/timeline") ? "mr-2 contentItemTitle contentItemTitleTimeLine" : "mr-2 contentItemTitle"}
          onClick={() => {
            openContent(item._id);
          }}
        >
          {item.title}
        </div>
        <OpenCIIcon
          className={`openCIIcon ${localStorage.getItem("entityLanguage") === "English" ? "ml-auto" : "mr-auto"}`}
          onClick={() => {
            openContent(item._id);
          }}
        />
        {item.type !== "external_link" ? (
          <DownLoadIcon
            className={`downloadIcon ${localStorage.getItem("entityLanguage") === "English" ? "ml-2" : "mr-2"}`}
            onClick={(e) => {
              downloadContent(e, item._id);
            }}
          />
        ) : null}
      </div>
      {mode && mode === "insideFolder" && (
        <div>
          <div className={`contentItemDescription mt-2 ${localStorage.getItem("entityLanguage") === "English" ? null : "mr-3 alignRight"}`}>{item.description}</div>
        </div>
      )}
    </div>
  ) : (
    <div>None</div>
  );
};

export default CurriculumCI;